import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const NavigationButton = (props) =>
{
    return (
        <Fragment>
            <div className='nav-desktop'>
                <Link to={props.item.url}>
                    <button>
                        <img src={props.item.image} alt={props.item.alt}/><span className='nav-button-text'>{props.item.text}</span>
                    </button>
                </Link>
            </div>
        </Fragment>
    )
}

export default NavigationButton ;